<script setup lang="ts">
import { type IBookBase } from "~/types/book";

interface IProps {
  html: string;
  books?: IBookBase[];
}

interface TextPart {
  type: 'text';
  data: string;
}

interface ComponentPart {
  type: 'component';
  data: IBookBase;
}

type ProcessedPart = TextPart | ComponentPart;

const props = withDefaults(defineProps<IProps>(), {
  books: (): IBookBase[] => []
});

const regex = /(<p>)?\[book:(\d+)\](<\/p>)?/g;
const parts = props.html.split(regex);

const d = parts.flatMap((part, index) => {
  if (index % 4 === 2) {
    const bookId = parseInt(part, 10);
    const book = props.books.find((b) => b.id === bookId);
    if (book) {
      return [{ type: 'component', data: book }] as ProcessedPart[];
    }
  }

  if (index % 4 === 1 || index % 4 === 3) {
    return [];
  }

  return [{ type: 'text', data: part.trim() }] as ProcessedPart[];
});
</script>

<template>
  <div class="flex flex-col gap-8">
    <template v-for="(part, index) in d" :key="index">
      <lazy-content-book-card v-if="part.type === 'component'" :book="part.data" />
      <div
          v-else
          v-html="part.data"
          class="content-block flex flex-col gap-8 text-xl leading-6 text-gray-800 dark:text-gray-300 font-light max-md:text-lg max-md:leading-[22px] max-md:gap-4"
      />
    </template>
  </div>
</template>

<style lang="scss">

</style>